<template>
  <div>
    <v-toolbar class="mx-3" flat color="transparent">
      <v-btn @click="$router.go(-1)" icon exact>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>
        Cadastrar endereço
      </v-toolbar-title>
    </v-toolbar>

    <v-container>
      <v-row>
        <v-col>
          <v-form @submit.prevent="submit">
            <ValidationObserver ref="form">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <ValidationProvider name="cep" v-slot="{ errors }" lazy>
                        <v-text-field
                          name="cep"
                          v-model="form.cep"
                          label="CEP"
                          v-mask="'#####-###'"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="4">
                      <ValidationProvider name="uf" v-slot="{ errors }">
                        <v-text-field
                          v-model="form.uf"
                          label="Estado"
                          counter="2"
                          name="uf_entrega"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col>
                      <ValidationProvider name="cidade" v-slot="{ errors }">
                        <v-text-field
                          v-model="form.cidade"
                          label="Cidade"
                          counter="45"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="9">
                      <ValidationProvider name="rua" v-slot="{ errors }">
                        <v-text-field
                          v-model="form.rua"
                          label="Rua / Avenida"
                          autofocus
                          counter="100"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col>
                      <ValidationProvider name="numero" v-slot="{ errors }">
                        <v-text-field
                          v-model="form.numero"
                          label="Número"
                          name="numero"
                          counter="10"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <ValidationProvider name="bairro" v-slot="{ errors }">
                        <v-text-field
                          v-model="form.bairro"
                          label="Bairro"
                          :error-messages="errors"
                          counter="45"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        name="complemento"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.complemento"
                          label="Complemento"
                          :error-messages="errors"
                          counter="45"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text>
                    Cancelar
                  </v-btn>
                  <v-btn type="submit" color="primary" :loading="loading">
                    Cadastrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </ValidationObserver>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import api from "@/services/locacoes.js";

export default {
  mixins: [],

  components: {},

  props: {
    codigo: String
  },

  data() {
    return {
      form: {
        cep: "13700-000",
        uf: "SP",
        cidade: "Casa Branca"
      },
      loading: false
    };
  },

  methods: {
    async submit() {
      this.loading = true;
      this.$refs.form.reset();

      try {
        await api.locacoes.cadastrarEndereco(this.codigo, this.form);
        this.$router.go(-1);
      } catch (error) {
        if (error.response?.status === 422) {
          this.$refs.form.setErrors(error.response.data.errors);
          return;
        }
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {}
};
</script>
